module.exports = __webpack_public_path__ + "static/media/news2.e3cb79e2.jpg";